import {
  CREATE_USER_FAILD,
  CREATE_USER_LOADING,
  CREATE_USER_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  userId: null,
  status: null,
};

export const createUserReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case CREATE_USER_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userId: action.payload,
        status: action.status,
        error: null,
      };
    case CREATE_USER_FAILD:
      return {
        ...state,
        loading: false,
        userId: null,
        status: null,
        error: action.error,
      };
    default:
      return state;
  }
};
